exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pi-areas__head[data-v-1e941787]{display:flex;flex-wrap:wrap;align-items:flex-start;justify-content:space-between;gap:8px 16px;margin:0 0 12px}.pi-areas__lead[data-v-1e941787]{flex:1 1 420px;margin:0}.pi-areas__asof[data-v-1e941787]{display:inline-flex;align-items:center;gap:4px}.pi-areas__grid[data-v-1e941787]{display:grid;grid-template-columns:repeat(auto-fill,minmax(340px,1fr));gap:14px}.pi-areas__hint[data-v-1e941787]{margin-bottom:10px}@media (max-width:767px){.pi-areas__grid[data-v-1e941787]{grid-template-columns:minmax(0,1fr)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e941787","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/vue/pages/restricted/productIntelligence/piAreas.vue
// module id = 1707
// module chunks = 0